import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatHint, MatLabel } from '@angular/material/form-field';
import { EditorModule } from '@tinymce/tinymce-angular';
import { FormlyErrorComponent } from '../formly-error.component';
import { FormlyDataCyDirective } from '../../directives/formly-data-cy.directive';
import { FieldLabelRowComponent } from './field-label-row.component';

@Component({
  selector: 'formly-field-editor',
  template: `
    @if (field.props.label) {
      <mat-label class="inline-block mb-1 font-medium">
        <app-field-label-row
          [label]="field.props.label + (field.props.required ? ' *' : '')"
          [required]="field.props.required"
          [info]="props.info"></app-field-label-row>
      </mat-label>
    }
    <editor
      [disabled]="props.disabled"
      [formControl]="formControl"
      [init]="editorConfig"
      licenseKey="gpl"
      [formlyAttributes]="field"
      [formlyDataCy]="field">
    </editor>
    @if (field.props.description) {
      <mat-hint class="inline-block mb-2">{{ field.props.description }}</mat-hint>
    }
    <app-formly-error [field]="field"></app-formly-error>
  `,
  imports: [
    ReactiveFormsModule,
    FormlyModule,
    MatLabel,
    EditorModule,
    FormlyErrorComponent,
    MatHint,
    FormlyDataCyDirective,
    FieldLabelRowComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyEditorType extends FieldType implements OnInit {
  editorConfig: any;

  ngOnInit() {
    this.editorConfig = {
      base_url: '/tinymce',
      suffix: '.min',
      plugins: 'link code lists placeholder',
      removePlugins: 'drag drop',
      branding: false,
      toolbar:
        'undo redo | formatselect | h1 h2 h3 h4 | bold italic | alignleft aligncenter alignright | bullist numlist | link | code',
      height: 400,
      menubar: false,
      inline_styles: true,
      convert_fonts_to_spans: true,
      email_mode: true,
      placeholder: this.field.props?.placeholder || '',
      content_style: `
        body {
          font-family: Arial, sans-serif;
          margin: 1rem !important;
          padding: 0 !important;
        }
        p { margin: 0; padding: 0; }
        h1, h2, h3, h4 { margin: 0; }
        h1 { font-size: 2em; }
        h2 { font-size: 1.5em; }
        h3 { font-size: 1.17em; }
        h4 { font-size: 1em; }
        ol, ul { padding-left: 1.5em; margin: 0; }
        a { color: #06c; text-decoration: underline; }
        .mce-content-body[data-mce-placeholder]:not(.mce-visualblocks)::before {
          color: #999;
          font-style: italic;
        }
      `,
    };
  }
}

/**  Copyright 2018 Google Inc. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at http://angular.io/license */
